import { translate } from "@/plugins/i18n";
import BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";

export class EnumEireMovementType implements BaseEnumType {
  private static allValues: EnumEireMovementType[] = []; // make sure this is top-most
  
  public static unknown = new EnumEireMovementType(0, "Unknown", "enum_eire_movement_type_unknown");
  public static otherMemberStatesOfEu = new EnumEireMovementType(1, "OtherMemberStatesOfEu", "enum_eire_movement_type_other_member_states_of_eu");
  public static thirdCountries = new EnumEireMovementType(2, "ThirdCountries", "enum_eire_movement_type_third_countries");
  public static otherWarehouses = new EnumEireMovementType(3, "OtherWarehouses", "enum_eire_movement_type_other_warehouses");
  public static distillery = new EnumEireMovementType(4, "Distillery", "enum_eire_movement_type_distillery");
  public static operations = new EnumEireMovementType(5, "Operations", "enum_eire_movement_type_operations");
  public static increasesInOperations = new EnumEireMovementType(6, "IncreasesInOperations", "enum_eire_movement_type_increases_in_operations");
  public static deficienciesReturned = new EnumEireMovementType(7, "DeficienciesReturned", "enum_eire_movement_type_deficiencies_returned");
  public static homeConsumption = new EnumEireMovementType(8, "HomeConsumption", "enum_eire_movement_type_home_consumption");
  public static lossesInOperations = new EnumEireMovementType(9, "LossesInOperations", "enum_eire_movement_type_losses_in_operations");
  public static dutyFreeShops = new EnumEireMovementType(10, "DutyFreeShops", "enum_eire_movement_type_duty_free_shops");
  public static shipsStores = new EnumEireMovementType(11, "ShipsStores", "enum_eire_movement_type_ships_stores");
  public static inFlightCatering = new EnumEireMovementType(12, "InFlightCatering", "enum_eire_movement_type_in_flight_catering");
  public static diplomaticPrivilege = new EnumEireMovementType(13, "DiplomaticPrivilege", "enum_eire_movement_type_diplomatic_privilege");
  public static otherDutyFreeUse = new EnumEireMovementType(14, "OtherDutyFreeUse", "enum_eire_movement_type_other_duty_free_use");
  public static denaturing = new EnumEireMovementType(15, "Denaturing", "enum_eire_movement_type_denaturing");
  public static destruction = new EnumEireMovementType(16, "Destruction", "enum_eire_movement_type_destruction");
  public static dutiableDeficiencies = new EnumEireMovementType(17, "DutiableDeficiencies", "enum_eire_movement_type_dutiable_deficiencies");
  public static dutyExemptDeficiencies = new EnumEireMovementType(18, "DutyExemptDeficiencies", "enum_eire_movement_type_duty_exempt_deficiencies");
  public static other = new EnumEireMovementType(19, "Other", "enum_eire_movement_type_other");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumEireMovementType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isUnknown() { return this === EnumEireMovementType.unknown; }
  public isOtherMemberStatesOfEu() { return this === EnumEireMovementType.otherMemberStatesOfEu; }
  public isThirdCountries() { return this === EnumEireMovementType.thirdCountries; }
  public isOtherWarehouses() { return this === EnumEireMovementType.otherWarehouses; }
  public isDistillery() { return this === EnumEireMovementType.distillery; }
  public isOperations() { return this === EnumEireMovementType.operations; }
  public isIncreasesInOperations() { return this === EnumEireMovementType.increasesInOperations; }
  public isDeficienciesReturned() { return this === EnumEireMovementType.deficienciesReturned; }
  public isHomeConsumption() { return this === EnumEireMovementType.homeConsumption; }
  public isLossesInOperations() { return this === EnumEireMovementType.lossesInOperations; }
  public isDutyFreeShops() { return this === EnumEireMovementType.dutyFreeShops; }
  public isShipsStores() { return this === EnumEireMovementType.shipsStores; }
  public isInFlightCatering() { return this === EnumEireMovementType.inFlightCatering; }
  public isDiplomaticPrivilege() { return this === EnumEireMovementType.diplomaticPrivilege; }
  public isOtherDutyFreeUse() { return this === EnumEireMovementType.otherDutyFreeUse; }
  public isDenaturing() { return this === EnumEireMovementType.denaturing; }
  public isDestruction() { return this === EnumEireMovementType.destruction; }
  public isDutiableDeficiencies() { return this === EnumEireMovementType.dutiableDeficiencies; }
  public isDutyExemptDeficiencies() { return this === EnumEireMovementType.dutyExemptDeficiencies; }
  public isOther() { return this === EnumEireMovementType.other; }

  public static getValues(): readonly EnumEireMovementType[] {
    return EnumEireMovementType.allValues;
  }

  public static getValuesExcept0(): readonly EnumEireMovementType[] {
    return EnumEireMovementType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumEireMovementType {
    const found = EnumEireMovementType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumEireMovementType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumEireMovementType): EnumEireMovementType {
    const found = name ? EnumEireMovementType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumEireMovementType - Value not found: ${ name }`);
    }

    return found;
  }
}